import {
  TextNode,
  NodeKey,
  EditorConfig,
  createCommand,
  $getSelection,
  $setSelection,
  $isRangeSelection,
  SerializedTextNode,
  $createTextNode,
} from 'lexical';
import { moveForwardOrCreateNextNode } from 'src/components/custom/Editor/utils';

export class CodeHighLightNode extends TextNode {
  __className: string = 'iva-editor-text-code';

  constructor(text: string, className?: string, key?: NodeKey) {
    super(text, key);
    this.__className = className || this.__className;
  }

  static getType(): string {
    return 'iva-editor-text-code';
  }

  static clone(node: CodeHighLightNode): CodeHighLightNode {
    return new CodeHighLightNode(node.__text, node.__className, node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = super.createDOM(config);
    element.classList.toggle(this.__className);
    return element;
  }

  exportJSON() {
    const json = {
      ...super.exportJSON(),
      type: this.getType(),
    };
    return json;
  }

  static importDOM() {
    return {
      span: (node: HTMLElement) => {
        if (node.classList.contains('iva-editor-text-code')) {
          return {
            conversion: (el: HTMLElement) => {
              return {
                node: $createCodeHighLightNode(el?.innerText || ''),
              };
            },
            priority: 1 as const,
          };
        }
        return null;
      },
    };
  }

  static importJSON(serializedNode: SerializedTextNode) {
    const node = $createCodeHighLightNode(serializedNode.text);

    return node;
  }
}

export function $createCodeHighLightNode(
  text: string,
  className?: string,
): CodeHighLightNode {
  return new CodeHighLightNode(text, className);
}

export function $isCodeHighLightNode(node?: any): node is CodeHighLightNode {
  return node instanceof CodeHighLightNode;
}

export const INSERT_CODE_HIGHLIGHT_COMMAND = createCommand<boolean>();

export const toggleHighlightCode = (isCode: boolean) => {
  const selection = $getSelection();

  if (selection !== null) {
    $setSelection(selection);
  }
  const sel = $getSelection();

  if (!$isRangeSelection(sel)) return;
  if (sel.isCollapsed()) return;

  if (isCode) {
    const nodes = sel.extract();
    if (!nodes.length) return;

    if (nodes.length === 1) {
      return sel.insertNodes([$createTextNode(sel.getTextContent())]);
    }

    nodes.forEach((node) => {
      if (!$isCodeHighLightNode(node)) {
        return sel.insertNodes([
          $createCodeHighLightNode(sel.getTextContent()),
        ]);
      }
    });
  } else {
    sel.insertNodes([$createCodeHighLightNode(sel.getTextContent())]);
    moveForwardOrCreateNextNode(sel);
  }
};
